"use client";

import { PasswordResetUser } from "@/types/passwordReset";

import { usePasswordReset } from "@/context/passwordReset";

import LookupButton from "@/components/lookup/button";
import StepButtonWrapper from "@/components/wrapper/stepButton";

export default function VerifyButton() {
  const { errors, getPasswordResetUser, passwordResetUser } =
    usePasswordReset();

  return (
    <StepButtonWrapper
      button={
        <LookupButton<PasswordResetUser>
          entity={passwordResetUser}
          errors={errors}
          onClick={getPasswordResetUser}
          tooltipSuffix="to verify your identity"
        />
      }
    />
  );
}
